import { Chess } from 'chess.js';
// Row 0 is rank 8 (Black's back rank), row 7 is rank 1 (White's back rank).
export function parseFenBoard(fen) {
    const chess = new Chess(fen);
    return chess.board().map(row => row.map(square => square
        ? {
            square: square.square,
            type: square.type,
            color: square.color === 'w' ? 'white' : 'black',
        }
        : null));
}
//# sourceMappingURL=board.js.map